/* eslint-disable no-undef */

import React from 'react';
import { View, Text } from 'react-native';
import makeAPICallz from '../api';

const hocWithFetcher = Component => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        data: null,
        isLoading: false,
        error: null,
        id: 0,
        transactionIDs: []
      };
    }

    changeTransactionId = txnId => {
      var secret = '';
      var latest = this.state.transactionIDs.filter(function(val) {
        if (val.transactionId == txnId) {
          secret = val.secret.substring(
            0,
            val.secret.length - val.transactionId.length
          );
          return false;
        }
        return true;
      });
      this.setState({ transactionIDs: latest });
      return secret;
    };

    generate = length => {
      var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
        result = '';
      for (var i = length; i > 0; --i)
        result += chars[Math.round(Math.random() * (chars.length - 1))];
      return result;
    };

    makeAPICall = (
      request,
      successCallback,
      failureCallback,
      loadingCallback
    ) => {
      const loadingFunc = typeof loadingCallback === 'function';
      const receiveResponseFunc = typeof successCallback === 'function';
      const errorFunc = typeof failureCallback === 'function';

      var length = Math.floor(Math.random() * 10) + 3;
      var salt = Math.floor(Math.random() * 10) + 4;
      var id = this.state.id;
      var transactionId =
        Math.random()
          .toString(36)
          .substring(2, length) +
        Math.random()
          .toString(36)
          .substring(2, salt) +
        id;
      var secret =
        Math.random()
          .toString(36)
          .substring(2, 15) +
        Math.random()
          .toString(36)
          .substring(2, 15);
      var secretNew = secret + this.generate(transactionId.length);
      var latestTransaction = {
        transactionId: transactionId,
        secret: secretNew
      };
      if (request.payload == '') request.payload = {};
      request.payload.txnId = transactionId;

      this.setState(prevState => ({
        transactionIDs: [...prevState.transactionIDs, latestTransaction],
        id: prevState.id + 1
      }));
      loadingFunc ? loadingCallback(true) : this.setState({ isLoading: true });
      makeAPICallz(request, this.changeTransactionId, secret)
        .then(result => {
          // const jsonResponse = result.data;
          // jsonResponse.tag = result.tag;

          if (receiveResponseFunc && loadingFunc) {
            successCallback(result);
            loadingCallback(false);
          } else if (receiveResponseFunc) {
            successCallback(result);
            this.setState({
              isLoading: false
            });
          } else if (loadingFunc) {
            loadingCallback(false);
            this.setState({
              data: result
            });
          } else {
            this.setState({
              data: result,
              isLoading: false
            });
          }
        })
        .catch(error => {
          if (error.code === 499 || error.code === 403) {
            this.props.navigation.state.params.timeout = 1;
            this.props.navigation.navigate(
              'sessionTimeOut',
              this.props.navigation.state.params
            );
          }
          // TODO: handle all common error scenarios here
          if (errorFunc && loadingFunc) {
            failureCallback(error);
            loadingCallback(false);
          } else if (errorFunc) {
            failureCallback(error);
            this.setState({
              isLoading: false
            });
          } else if (loadingFunc) {
            loadingCallback(false);
            this.setState({
              error
            });
          } else {
            this.setState({
              error,
              isLoading: false
            });
          }
        });
    };

    render() {
      return (
        <Component
          registerDataReceived={this.registerDataReceived}
          registerLoading={this.registerLoading}
          registerError={this.registerError}
          makeAPICall={this.makeAPICall}
          {...this.props}
          {...this.state}
        />
      );
    }
  };
};

export { hocWithFetcher };
